export interface OauthRedirectResponse {
  redirect_url: string
}

type BaseRequest = {
  account_type: 'personal' | 'organizational'
  front_redirect_url: string
}

type RequestWithProvider = BaseRequest & {
  auth_method: 'provider'
  provider: 'google' | 'azure' | 'apple'
}

type RequestWithEmail = BaseRequest & {
  auth_method: 'email'
  email: string
}

export type OauthRedirectRequest = RequestWithProvider | RequestWithEmail
